import { useCallback, useEffect, useRef, useState } from 'react';

export function useHydrationSafeImageFallback(src: string | null | undefined) {
	const imageRef = useRef<HTMLImageElement>(null);
	const [failedSrc, setFailedSrc] = useState<string | null>(null);
	const showFallback = useCallback(() => {
		if (src) setFailedSrc(src);
	}, [src]);

	useEffect(() => {
		const image = imageRef.current;

		// An SSR image can fail before hydration attaches its error handler.
		if (image?.complete && image.naturalWidth === 0) showFallback();
	}, [showFallback]);

	return {
		hasFailed: Boolean(src && failedSrc === src),
		imageRef,
		showFallback,
	};
}
